module.exports = __webpack_public_path__ + "static/media/SantanderConsumer.33e9ef78.png";